import DashBoard from '../modules/Dashboard/components/index.vue';
import TenantList from '../modules/TenantManager/components/Index.vue';
import Login from '../modules/Login/components/Index.vue';
import Join from '../modules/Join/components/index.vue';
import ResetPasswordRequest from '../modules/ResetPassword/components/GetResetLink.vue';
import ResetPassword from "../modules/ResetPassword/components/ResetPassword";
import Token from '../modules/Login/components/Token.vue';
import SessionExpired from '../components/application/SessionExpired.vue';
import TrialExpired from '../components/application/TrialExpired.vue';
import UserManager from '../modules/UserManager/components/index.vue';
import PanelistImporter from '../modules/PanelistImporter/components/index.vue';
import AccountManager from '../modules/MyProfile/components/index.vue';
import SampleDefinitions from '../modules/Segments/components/index.vue';
import ProjectManager from '../modules/ProjectManager/components/index.vue';
import EditProject from '../modules/ProjectManager/components/EditProject/EditProject.vue';
import ListProjects from '../modules/ProjectManager/components/ListProjects.vue';
import SubPanels from '../modules/SubPanels/components/index.vue';
import EditSubPanel from '../modules/SubPanels/components/EditSubPanel.vue';
import ListSubPanels from '../modules/SubPanels/components/ListSubPanels.vue';
import PanelistManager from '../modules/PanelistManager/components/index.vue';
import EditPanelist from '../modules/PanelistManager/components/EditPanelist.vue';
import SearchPanelists from '../modules/PanelistManager/components/SearchPanelists.vue';
import PanelSettings from '../modules/PanelSettings/components/index.vue';
import RecruitmentSources from '../modules/RecruitmentSources/components/index.vue';
import Health from '../modules/Health/components/index.vue';
import Financial from '../modules/Financial/components/index.vue';
import Clients from '../modules/Clients/components/index.vue';
import Rewards from '../modules/Rewards/components/index.vue';
import Redemptions from '../modules/Redemptions/components/index';
import CommunicationsHub from '../modules/CommunicationsHub/components/index.vue';
import DataVariables from '../modules/DataVariables/components/index.vue';
import ListDataVariables from '../modules/DataVariables/components/ListDataVariables';
import EditDataVariable from '../modules/DataVariables/components/EditDataVariable';
import Announcements from '../modules/Announcements/components/index';
import TestGround from '../modules/TestGround/components/index';
import Locales from '../modules/Locales/components/index';
import Downloads from '../modules/Downloads/components/index';
import Feedback from '../modules/Feedback/components/index';
import ExchangeReporting from '../modules/ExchangeReporting/components/index';
import RegistrationStats from '../modules/RegistrationStats/components/index';
import ExternalSuppliers from '../modules/ExternalSuppliers/components/index';

export const Routes = [
    {path: '/', component: Login},
    {path: '/spa/dashboard', component: DashBoard},
    {path: '/spa/tenantmanager', component: TenantList},
    {path: '/spa/login', component: Login},
    {path: '/spa/token', component: Token},
    {path: '/spa/sessionexpired', component: SessionExpired},
    {path: '/spa/trialexpired', component: TrialExpired},
    {path: '/spa/password-reset', component: ResetPasswordRequest},
    {
        path: '/spa/password-reset/:token',
        component: ResetPassword,
        props: true,
    },
    {path: '/spa/settings', component: PanelSettings},
    {path: '/spa/join/:token', component: Join},
    {path: '/spa/usermanager', component: UserManager},
    {path: '/spa/account', component: AccountManager},
    {path: '/spa/recruitmentsources', component: RecruitmentSources},
    {path: '/spa/health', name: 'health', component: Health},
    {path: '/spa/financial', name: 'financial', component: Financial},
    {path: '/spa/clients', component: Clients},
    {path: '/spa/rewards', name: 'rewards', component: Rewards},
    {path: '/spa/redemptions', name: 'redemptions', component: Redemptions},
    {path: '/spa/communications', component: CommunicationsHub},
    {path: '/spa/segments', component: SampleDefinitions},
    {path: '/spa/announcements', component: Announcements},
    {path: '/spa/testground', component: TestGround},
    {path: '/spa/panelistimporter', component: PanelistImporter},
    {
        name: 'downloads',
        path: '/spa/downloads',
        component: Downloads
    },
    {path: '/spa/locales', component: Locales},
    {path: '/spa/exchange-reporting', component: ExchangeReporting},
    {path: '/spa/external-suppliers', component: ExternalSuppliers},
    {path: '/spa/feedback', component: Feedback},
    {path: '/spa/registrations', component: RegistrationStats},
    {
        path: '/spa/datavariables', component: DataVariables, children: [
            {
                name: 'data-variable-edit',
                path: 'edit/:id',
                component: EditDataVariable,
                props: true,
            },
            {
                name: 'data-variable-create',
                path: 'create/:type',
                component: EditDataVariable,
                props: true,
            },
            {
                name: 'data-variables-list',
                path: '',
                component: ListDataVariables,
            }
        ]
    },
    {
        path: '/spa/projectmanager', component: ProjectManager, children: [
            {
                name: 'project-manager-create',
                path: 'edit',
                component: EditProject,
                props: false,
            },
            {
                name: 'project-manager-edit',
                path: 'edit/:id',
                component: EditProject,
                props: true,
            },
            {
                name: 'project-manager-list',
                path: '',
                component: ListProjects
            }
        ]
    },
    {
        path: '/spa/subpanels', component: SubPanels, children: [
            {
                name: 'subpanels-list',
                path: '',
                component: ListSubPanels,
            },
            {
                name: 'subpanel-create',
                path: 'edit',
                component: EditSubPanel,
                props: false,
            },
            {
                name: 'subpanel-edit',
                path: 'edit/:id',
                component: EditSubPanel,
                props: true,
            },
        ]
    },
    {
        path: '/spa/panelistmanager', component: PanelistManager, children: [
            {
                name: 'panelist-manager-edit',
                path: 'edit/:id',
                component: EditPanelist,
                props: true
            },
            {
                // Leave empty for default
                name: 'panelist-manager-search',
                path: '',
                component: SearchPanelists
            }
        ]
    },
];
